export default __webpack_public_path__ + "static/media/code.54cff58a.jpg";